import { useDispatch, useSelector } from "react-redux";
import { MandatoryStar, getSnackbarSuccess } from "../../../Utils/helper";
import { getNetworkMenuId } from "../../../Utils/types";
import Select from "react-select";
import { useState } from "react";
import {
  approveRejectTestDetailsAction,
  getTestDetailNewPopupAction,
  getTestDetailUpdatePopupAction,
} from "../../../redux/actions/ProviderProfileDetailAction";
import { getSkuSearchTagValues } from "../TestPackages/Test/helper";

export const ConfirmationTestPopup = ({
  isApproveReject,
  setIsApproveReject,
  rowData,
  handleClose,
  newSearchFilterTest,
  updateSearchFilterTest,
}) => {
  const dispatch = useDispatch();
  const [remark, setRemark] = useState("");

  const providerPortalDetailReducer = useSelector(
    (state) => state?.providerPortalDetailReducer
  );
  const getTagListNetworkDetails = useSelector(
    (state) => state?.TestPackageReducer?.getTagListNetworkDetails
  );
  const ApproveRejectHandler = async (type) => {
    const temp = {
      requestID: rowData?.requestID,
      requestStatus: rowData?.requestStatus === "PendingAppPrice" ? "AppPriceDetail" : type,
      sessionID: rowData?.sessionID,
      providerFacilityStgId: isApproveReject?.providerFacilityStgId,
      facilityId: isApproveReject?.facilityId,
      agreedRate:
        isApproveReject?.agreedRate === "" ? 0 : isApproveReject?.agreedRate,
      remarks: remark,
      isFrequentlyUsedSKU: isApproveReject?.isFrequentlyUsedSKU,
      skuSerachTag: isApproveReject?.skuSerachTag,
      providerId:rowData?.providerID,
      appPrice1Graded:+isApproveReject?.appPrice1Graded
    };
    if(rowData?.requestStatus === "PendingAppPrice" && temp?.appPrice1Graded === 0){
      getSnackbarSuccess(
        "info",
        "App Price is required",
        dispatch
      );
    }
    else if (isApproveReject?.agreedRate == 0 && type === "APPROVED") {
      getSnackbarSuccess(
        "info",
        "agreed rate should be greater than 0",
        dispatch
      );
    } else if (
      isApproveReject?.facilityId === undefined ||
      isApproveReject?.facilityId === null ||
      (isApproveReject?.agreedRate === "" && type === "APPROVED")
    ) {
      getSnackbarSuccess(
        "info",
        "Please fill all the required fields",
        dispatch
      );
    } else if (type === "REJECTED" && /^\s*$/.test(remark)) {
      getSnackbarSuccess(
        "info",
        "Please specify the reason for rejecting this request ?",
        dispatch
      );
    } else {
      await dispatch(approveRejectTestDetailsAction(temp, handleClose));
      await dispatch(getTestDetailNewPopupAction(newSearchFilterTest));
      await dispatch(getTestDetailUpdatePopupAction(updateSearchFilterTest));
      await setIsApproveReject(null);
      await setRemark("");
    }
  };

  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">Approval Card </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => setIsApproveReject(null)}
        ></button>
      </div>
      <form className="form-admin test-confirmationpopup">
        <div className="modal-body addusermodalbox">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <label htmlFor=" Role" className="col-form-label">
                Agreed Rate
                <MandatoryStar />
              </label>
              <input
                type="text"
                placeholder="Agreed Rate"
                className="form-control form-select-admin inputbgavanish"
                value={isApproveReject?.agreedRate}
                onChange={(e) =>
                  setIsApproveReject({
                    ...isApproveReject,
                    agreedRate: e.target.value,
                  })
                }
                onKeyPress={(event) => {
                  const regex = /^[0-9]*(\.[0-9]{0,2})?$/;
                  if (!regex.test(isApproveReject?.agreedRate + event.key)) {
                    event.preventDefault();
                  }
                }}
                disabled={isApproveReject?.requestStatus !== "InReview"}
              />
            </div>
            {rowData?.detailType === "AppPriceDetail" && <div className="col-lg-6 col-md-6">
              <label htmlFor=" Role" className="col-form-label">
                App Price
                <MandatoryStar />
              </label>
              <input
                type="text"
                placeholder="App Price"
                className="form-control form-select-admin inputbgavanish"
                value={isApproveReject?.appPrice1Graded}
                onChange={(e) =>
                  setIsApproveReject({
                    ...isApproveReject,
                    appPrice1Graded: e.target.value,
                  })
                }
                onKeyPress={(event) => {
                  const regex = /^\d*\.?\d*$/;
                  if (!regex.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                disabled={isApproveReject?.requestStatus !== "PendingAppPrice"}
              />
            </div>}
            <div className="col-lg-6 col-md-6">
              <label htmlFor=" Role" className="col-form-label">
                HA SKU Code
                <MandatoryStar />
              </label>
              <Select
                className="basic-multi-select select_provider_test"
                classNamePrefix="select"
                name="colors"
                placeholder="HA SKU Code"
                isClearable={true}
                options={providerPortalDetailReducer?.getFacilityReason?.map(
                  (ele) => {
                    return {
                      value: ele?.facilityId,
                      label: ele?.facilityName,
                      isFrequentlyUsedSKU: ele?.isFrequentlyUsedSKU,
                      skuSerachTag: ele?.skuSerachTag,
                      agreedRate: ele?.agreedRate,
                    };
                  }
                )}
                onChange={(e) => {
                  setIsApproveReject({
                    ...isApproveReject,
                    facilityId: e?.value,
                    facilityName: e?.label,
                    isFrequentlyUsedSKU: e?.isFrequentlyUsedSKU,
                    skuSerachTag: e?.skuSerachTag,
                    agreedRate: e?.agreedRate,
                  });
                }}
                value={{
                  value: isApproveReject?.facilityId,
                  label: isApproveReject?.facilityName,
                }}
                isDisabled={isApproveReject?.requestStatus !== "InReview"}
              />
            </div>
            {/* <div className="col-lg-6 col-md-6 mt20">
              <label htmlFor=" Role" className="col-form-label">
                Is Frequently Used SKU
                <MandatoryStar />
              </label>
              <select
                name="isFrequentlyUsedSKU"
                className="form-select form-select-admin"
                value={isApproveReject?.isFrequentlyUsedSKU}
                onChange={(e) => {
                  setIsApproveReject({
                    ...isApproveReject,
                    isFrequentlyUsedSKU:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                        ? false
                        : e.target.value,
                  });
                }}
              >
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
            </div>
            <div className="col-lg-6 col-md-6 mt20">
              <label htmlFor=" Role" className="col-form-label">
                SKU Search Tag
              </label>
              <Select
                className="basic-multi-select background_select"
                classNamePrefix="select"
                placeholder="SKU Search Tag"
                name="colors"
                isMulti
                closeMenuOnSelect={false}
                options={getTagListNetworkDetails?.map((ele) => {
                  return {
                    value: ele?.tagName,
                    label: ele?.tagName,
                  };
                })}
                onChange={(e) => {
                  setIsApproveReject({
                    ...isApproveReject,
                    skuSerachTag: e?.map((ele) => ele.value)?.toString(),
                  });
                }}
                value={getSkuSearchTagValues(
                  getTagListNetworkDetails,
                  isApproveReject?.skuSerachTag
                )}
              />
            </div> */}
          </div>
          {rowData?.detailType !== "AppPriceDetail" && <div className="remarks mt-4 mb-5">
            <h5 className="font-bold text-black bottom-spacing-20 mb-3">
              Remarks
            </h5>
            <textarea
              className="textareaConfirmation font-medium"
              placeholder="Type Something Here..."
              onChange={(e) => setRemark(e.target.value)}
              value={
                isApproveReject?.requestStatus !== "InReview"
                  ? isApproveReject?.remarks
                  : remark
              }
              disabled={
                isApproveReject?.requestStatus !== "InReview" ||
                !getNetworkMenuId()?.canEdit
              }
            ></textarea>
          </div>}
        </div>
        <div className="modal-footer modal-footer-admin accept-reject-btns bottom-0  mt-4">
          {(isApproveReject?.requestStatus === "InReview" || isApproveReject?.requestStatus === "PendingAppPrice") &&
            getNetworkMenuId()?.canEdit && (
              <div className="d-flex justify-content-end flex-wrap gap-10">
                <button
                  type="button"
                  onClick={async () => {
                    if(rowData?.detailType === "AppPriceDetail"){
                      await ApproveRejectHandler("AppPriceDetail");
                    }else {
                      await ApproveRejectHandler("APPROVED");
                    }
                   
                  }}
                  className="approve-btn"
                >
                  Approve
                </button>
                {rowData?.detailType !== "AppPriceDetail" && <button
                  type="button"
                  onClick={async () => {
                    await ApproveRejectHandler("REJECTED");
                  }}
                  className="reject-btn"
                >
                  Reject
                </button>}
              </div>
            )}
        </div>
      </form>
    </>
  );
};
